import { type UseMutationResult, useMutation } from '@tanstack/react-query';

import authApi from '@/api/auth';
import { queryClient } from '@/app/config/react-query';
import { useErrorHandling } from '@/hooks/useErrorHandling';

const logout = (): Promise<void> => {
  return authApi.post('/logout');
};

export const useLogout = (): UseMutationResult<void, unknown, void> => {
  const handleErrors = useErrorHandling();

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      queryClient.clear();
    },
    onError: (error: unknown) => {
      handleErrors(error);
    },
  });
};
